// extracted by mini-css-extract-plugin
module.exports = {"Divider":"divider_Divider__yJGIN","Divider--grey-200":"divider_Divider--grey-200__khFJw","Divider--text-secondary":"divider_Divider--text-secondary__8p3wJ"};